<template>
  <div class="l-body">
    <Top/>
    <div class="wrap kf_bg">
      <div class="kf-wrap zheng">
        <div class="kf_sousuo">
          <div class="jilu">
            <div>
              <el-select  style="line-height:32px;height:32px" v-model="choose">
                <el-option v-for="data in objData" :label="data.game" :value="data.id" :key="data.id" @click.native="handleChange">{{data.game}}</el-option>
              </el-select>
            </div>
          </div>
          <div class="sousuo">
            <div class="search">
              <el-input type="text" placeholder="输入你想搜索的问题的关键词 可同时输入多个关键词，中间使用空格隔开"  v-model="word" style="width:324px;float: left;font-size:12px" />
              <!-- <el-button @click="shou">搜索</el-button> -->
            </div>
            <div  v-show="faqData.data&&faqData.data.length&&show5"  class="chufasousuo" >
                <i class="el-message-box__close el-icon-close clonse" @click="closeshow5"></i>
              <div class="wt">
                <li v-for="faq in faqData.data"  @click="question(faq.id,faq.answer,faq.question)" :key="faq.id"><a>{{faq.question}}</a></li>
                <el-dialog v-for=" data in questionData" :append-to-body="true"
                  :key="data.id"
                  :visible.sync="dialogVisible"
                  width="30%">
                  <span slot="title" style="color:#ff0000;">塔人问答</span>
				  <span>问题：{{data.title}}</span><br>
				  <br></br>
				  <span>答：</span><br>
                  <span v-html="data.content"></span>
                  <span slot="footer" class="dialog-footer">
                  <img src="/static/assets/wrong.jpg" @click="question1(data.id)"/>
				  <a href="http://wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDEwMzM3N180NTIzMjdfODAwMTAzMzc3XzJf"><img src="/static/assets/service.jpg" /></a>
                  </span>
                </el-dialog>
              </div>
              <div class="pagei">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
              </div>
          </div>
        </div>
      </div>
      <div class="kf-jl-box_ls" >
        <div class="kf-wrap zheng">
          <h1>请选择您参与的游戏</h1>
          <h2>GAME SELECTION</h2>
          <div class="game_list">
            <div class="fl mod_guide qtab_container">
              <div class="qtab_nav fl clearfix">
				<li class="left_nav_1" class="current"><a>全部游戏</a></li>
              </div>

              <div class="qtab_wrapper fl" >
                <div class="qtab_slide fl" style="display: block">
                  <div>
                    <li v-for="data in objData" @click='ifVipGame(data.id,data.game)' :key="data.id"><img :src="getImgUrl(data.game)"/><span>{{data.game}}</span></li>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h1>新闻公告</h1>
          <h2>NEWS UPDATE</h2>
          <div class="kf_index_news fl">
            <li v-for="data in newData" :style="{backgroundImage: 'url('+ bg(data.picture) +')' }" :key="data.picture">
              <h1><a @click="$router.push({path:'/news', query:{id:data.id}})">{{data.title}}</a></h1>
              <p class="wenzi" style="word-break : break-all">{{data.introduce}}</p>
              <p><span><a @click='$router.push({path:"/newslist"})'>+查看更多</a></span><i>{{data.time}}</i></p>
            </li>
          </div>
          <div class="kf_index_lianjie fl">
            <a href='http://yht.zhaouc.net/'>塔人一号通</a> | <a href="http://vip.zhaouc.com/">塔人贵宾中心</a> | <a href="http://www.tarenwang.com">塔人网络官网</a> | <a href='http://pay.tarenwang.com/'>游戏充值</a> | <a href='http://www.zhaouc.com/taren/jzjh/'>家长监护</a> | <a href='http://my.zhaouc.com/apps/index.php/home/index/userinfo'>防沉迷</a>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Top from '@/components/top.vue'
  export default {
    name: 'Home',
	components: {
	  Top
	},
    data () {
      return {
        choose:4,
        total:0,
        word:'',
        objData:[{id: 4, game: "仙境传说起源", type: "1", order: 5, show: null}],
        newData:[],
        faqData:[],
        show5:false,
        type:"all",
        dialogVisible: false,
        questionData:[],
        page:1,
      }
    },
    created() {
		this.getNews()
    },
    watch: {
      word () {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.page=1
          this.shou()
        }, 500)
      },
    },
    methods:{
      bg(img){
        return "http://kf.zhaouc.com"+img.replace("\\","\/")
      },
      getfaq(){
        this.show5=true
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/top',
          params: {
            game_id:this.choose,
            page:this.page
          }
        }).then(res => {
          if(res.data.status==200){
            this.faqData=res.data
            this.total = res.data.count
          }else{
            this.faqData=[]
            this.total = 0
          }
        })
      },
      question(theid,meg,meg1){
        this.dialogVisible=true
        this.questionData=[]
        this.questionData .push({
          "title" : meg1,
          "content" : meg,
          "id" : theid,
        });
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/addcount',
          params: {
            id:theid,
          }
        })
      },
      question1(id){
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/haserror',
          params: {
            id:id,
          }
        })
		this.dialogVisible=false
		this.$alert('已经提交给客服！', {
			confirmButtonText: '确定',
		});
      },
      shou(){
          this.show5=true
          this.$axios({
            method: 'get',
            url: '/index.php/user/User/input',
            params: {
              game_id:this.choose,
              keyword:this.word,
              page:this.page
            }
          }).then(res => {
            if(res.data.status==200){
              this.faqData=res.data
              this.total = res.data.count
            }else if(res.data.status==500){
              this.faqData=[]
              this.total = 0
			  this.$confirm('暂无相关问题，是否提交问题给客服？', {
				confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
					this.$prompt('请输你想提交的问题',  {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({ value }) => {
						this.$axios({
						  method: 'post',
						  url: '/index.php/user/User/loadquestion',
						  data: {
						    game:this.choose,
						    question:this.word,
						  }
						}).then(res => {
							if(res.data.status==200){
							  this.$alert('已经提交给客服！', {
							  	confirmButtonText: '确定',
							  });
							}
						})
					})
				})
            }
          })
      },
      handleCurrentChange: function(currentPage){
        this.page = currentPage;
		if(this.word.length==0){
			this.getfaq()
		}else{
			this.shou()
		}
      },
      handleChange(){
		this.word=''
        this.page=1
        this.getfaq()
        this.show5=true;
      },
      getNews() {
        this.$axios({
          method: 'get',
          url: '/index.php/user/User/topnews'
        }).then(res => {
          if(res.data.status==200) {
            this.newData = res.data.data
          }
        })
      },
      ifVipGame(gid,gname){
        if(gid==1||gid==3){
          this.$axios({
            method: 'get',
            url: '/index.php/user/User/yzlogin'
          }).then(res => {
            if(res.data.status==500) {
              this.$alert('此账号仅可提交奇迹MU VIP区的问题', {
              	confirmButtonText: '确定',
              });
            }else{
              this.$router.push({path:"/serve",query:{id:gid,name:gname}})
            }
          })
        }else{
          this.$router.push({path:"/serve",query:{id:gid,name:gname}})
        }
      },
      getImgUrl(icon){
        return ("/static/assets/"+icon+".jpg");
      },
      closeshow5(){
        this.show5=false
      },
    }
  }
</script>
<style scoped>
  .clonse{position: absolute;right:5px;top:5px;z-index: 999999;cursor:pointer}
</style>



// WEBPACK FOOTER //
// src/views/home.vue